import { render, staticRenderFns } from "./index-v2.vue?vue&type=template&id=ed13e0d8&scoped=true&"
import script from "./index-v2.vue?vue&type=script&lang=js&"
export * from "./index-v2.vue?vue&type=script&lang=js&"
import style0 from "./index-v2.vue?vue&type=style&index=0&id=ed13e0d8&lang=scss&scoped=true&"
import style1 from "./index-v2.vue?vue&type=style&index=1&id=ed13e0d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed13e0d8",
  null
  
)

export default component.exports